import { createApp } from 'vue'
import AdetGunu from './AdetGunu.vue'
import './assets/global.css'

createApp(AdetGunu).mount('#regl')
